<script setup>
import { computed, onMounted } from 'vue';

import { useActiveStudyStore } from '../store/active-study';

import { ContourLabel } from '../store/contours/contour-definitions';
import { useViewportStateStore } from '../store/contours/viewport-state-store';

import ImageBarNew from './ImageBarNew.vue';
import StateButtons from './StateButtons.vue';
import VtkTwoView from './VtkTwoView.vue';

// defineProps replaces the props option
const props = defineProps({
  viewerID: { type: String },
  title: { type: String },
});

const activeStore = useActiveStudyStore();
const viewportStateStore = useViewportStateStore();

const updateContourTools = () => {
  viewportStateStore.setAllowedContourLabels(props.viewerID, [
    ContourLabel.SaxLvEndo,
    ContourLabel.SaxLvEpi,
    ContourLabel.RvInsertion,
    ContourLabel.SaxRvEndo,

    ContourLabel.LaxLvEndo,
    ContourLabel.LaxLvEpi,

    ContourLabel.GeneralPolygon,
    ContourLabel.GeneralLine,
    ContourLabel.AnnotationArrow,
    ContourLabel.AnnotationText,
  ]);
};

onMounted(() => {
  updateContourTools();
});

const currentImageIndices = computed(() =>
  viewportStateStore.getSelectedImageIndices(props.viewerID),
);

const seriesID = computed(() =>
  currentImageIndices.value.seriesIdx !== null
    ? String(currentImageIndices.value.seriesIdx)
    : null,
);

const currentSliceIndex = computed(() => currentImageIndices.value.sliceIdx);

const currentPhase = computed(() => currentImageIndices.value.imageIdx);

const allSliceStates = computed(() =>
  activeStore.getStudyStates(seriesID.value, currentSliceIndex.value),
);

const currentState = computed(() => {
  return activeStore.getStudyStatebyIndex(
    seriesID.value,
    currentSliceIndex.value,
    currentPhase.value,
  );
});
</script>

<template>
  <div class="viewer-container">
    <VtkTwoView :id="viewerID" key="sagitalv" class="flex-1" :title="title" />
    <ImageBarNew :viewer-i-d="viewerID" />
    <div class="state-buttons gap-4">
      <StateButtons
        v-for="(stateObj, stateName, index) in allSliceStates"
        :key="index"
        :state="stateName"
        :state-obj="stateObj"
        :is-active="currentState === stateName"
      />
    </div>
  </div>
</template>

<style scoped>
.viewer-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.state-buttons {
  display: flex;
  justify-content: space-between;
}
</style>
